import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getAppointmentTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get(`/api/resource/Appointment Type`);
  return data;
});
export const getAppointmentTypesDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Appointment Type/${id}`
  );
  return data;
});
export const updateAppointmentTypes = catchAsync(async (body) => {
  const { oldName, ...resetBody } = body;
  const { data } = await axiosInstance.put(
    `/api/resource/Appointment Type/${oldName}`,
    body ? resetBody : {}
  );
  return data;
});
export const addAppointmentTypes = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Appointment Type',
    body
  );
  return data;
});
export const getAppointmentsDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_appointment?appointment=${id}`
  );
  return data;
});

export const deleteAppointmentTypes = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Appointment Type/${id}`
  );
  return data;
});
